/* [BD] Trust Experts — bd-trust-experts.liquid (Swiper + tabs) */
;(function () {
  var bdTeSwiperWaitMs = 50;
  var bdTeSwiperWaitMax = 120;
  var bdTeDesktopBp = 990;

  function waitForBdTeSwiper(cb, left) {
    if (typeof window.Swiper === 'function') {
      cb();
      return;
    }
    left = typeof left === 'number' ? left : bdTeSwiperWaitMax;
    if (left <= 0) return;
    setTimeout(function () {
      waitForBdTeSwiper(cb, left - 1);
    }, bdTeSwiperWaitMs);
  }

  function destroyBdTePanelSwiper(panel) {
    var sw = panel._bdTeSwiper;
    if (sw && typeof sw.destroy === 'function') {
      try {
        sw.destroy(true, true);
      } catch (e) {}
      panel._bdTeSwiper = null;
    }
  }

  function padTwoDigits(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function updateBdTeCounter(panel, swiper) {
    var el = panel.querySelector('[data-bd-te-curr]');
    if (!el || !swiper) return;
    var i = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
    if (i < 0 || isNaN(i)) i = 0;
    el.textContent = padTwoDigits(i + 1);
  }

  function initBdTePanelSwiper(panel) {
    destroyBdTePanelSwiper(panel);
    var el = panel.querySelector('[data-bd-te-swiper]');
    if (!el || typeof window.Swiper !== 'function') return;

    var count = el.querySelectorAll('.swiper-slide').length;
    if (count <= 1) return;

    var root = panel.closest('[data-bd-te-section]');
    function readSpv(attr, fallback, min, max) {
      var v = parseFloat(root && root.getAttribute(attr));
      if (isNaN(v)) v = fallback;
      if (v < min) v = min;
      if (v > max) v = max;
      return v;
    }
    var requestedDesktop = readSpv('data-bd-te-slides-per-view', 4, 1, 6);
    var requestedMobile = readSpv('data-bd-te-slides-per-view-mobile', 1.2, 1.2, 6);
    var spvDesktop = Math.min(requestedDesktop, count);
    var spvMobile = Math.min(requestedMobile, count);
    var maxSpv = Math.max(spvMobile, spvDesktop);

    var prevEl = panel.querySelector('.bd-te__nav-btn--prev');
    var nextEl = panel.querySelector('.bd-te__nav-btn--next');

    var breakpoints = {};
    breakpoints[bdTeDesktopBp] = {
      slidesPerView: spvDesktop,
    };

    var opts = {
      slidesPerView: spvMobile,
      spaceBetween: 20,
      centeredSlides: true,
      breakpoints: breakpoints,
      loop: count > 1 && count > maxSpv,
      navigation:
        prevEl && nextEl
          ? {
              prevEl: prevEl,
              nextEl: nextEl,
            }
          : undefined,
      on: {
        afterInit: function (sw) {
          updateBdTeCounter(panel, sw);
        },
        slideChange: function (sw) {
          updateBdTeCounter(panel, sw);
        },
      },
    };

    if (!opts.navigation) delete opts.navigation;

    var swiper;
    try {
      swiper = new window.Swiper(el, opts);
    } catch (err) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[bd-trust-experts] Swiper init failed', err);
      }
      return;
    }
    panel._bdTeSwiper = swiper;
  }

  function destroyBdTeRoot(root) {
    if (!root) return;
    root.querySelectorAll('[data-bd-te-panel]').forEach(destroyBdTePanelSwiper);
    if (root._bdTeOnTabClick) {
      root.removeEventListener('click', root._bdTeOnTabClick);
      root._bdTeOnTabClick = null;
    }
    root.removeAttribute('data-bd-te-init');
  }

  function initBdTeRoot(root) {
    if (!root || root.getAttribute('data-bd-te-init')) return;
    if (typeof window.Swiper !== 'function') return;
    root.setAttribute('data-bd-te-init', '1');

    root._bdTeOnTabClick = function (e) {
      var tab = e.target.closest('[data-bd-te-tab]');
      if (!tab || !root.contains(tab)) return;
      var id = tab.getAttribute('data-bd-te-tab');
      root.querySelectorAll('[data-bd-te-tab]').forEach(function (t) {
        var on = t.getAttribute('data-bd-te-tab') === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-bd-te-panel]').forEach(function (p) {
        var on = p.getAttribute('data-bd-te-panel') === id;
        if (on) {
          p.removeAttribute('hidden');
          requestAnimationFrame(function () {
            initBdTePanelSwiper(p);
          });
        } else {
          destroyBdTePanelSwiper(p);
          p.setAttribute('hidden', '');
        }
      });
    };
    root.addEventListener('click', root._bdTeOnTabClick);

    root.querySelectorAll('[data-bd-te-panel]:not([hidden])').forEach(initBdTePanelSwiper);
  }

  function initBdTrustExperts(scope) {
    var roots = (scope || document).querySelectorAll('[data-bd-te-section]');
    if (!roots.length) return;
    waitForBdTeSwiper(function () {
      roots.forEach(initBdTeRoot);
    });
  }

  function reloadBdTrustExperts(scope) {
    var roots = (scope || document).querySelectorAll('[data-bd-te-section]');
    if (!roots.length) return;
    waitForBdTeSwiper(function () {
      roots.forEach(function (root) {
        destroyBdTeRoot(root);
        initBdTeRoot(root);
      });
    });
  }

  function boot(scope) {
    initBdTrustExperts(scope || document);
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode && !window.__bdSectionTrustExpertsDesignMode) {
    window.__bdSectionTrustExpertsDesignMode = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (!e.target) return;
      reloadBdTrustExperts(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.querySelector) return;
      var root = e.target.querySelector('[data-bd-te-section]');
      if (root) destroyBdTeRoot(root);
    });
  }
})();
